import { m as store_get, u as unsubscribe_stores, p as pop, b as push } from "../../chunks/index2.js";
import { p as page } from "../../chunks/stores.js";
import "clsx";
import "../../chunks/index3.js";
/* empty css                                                        */
import "../../chunks/theme.js";
import "../../chunks/score.js";
import "../../chunks/client.js";
function _layout($$payload, $$props) {
  push();
  var $$store_subs;
  {
    if (store_get($$store_subs ??= {}, "$page", page).url.pathname.startsWith("/login")) ;
    if (store_get($$store_subs ??= {}, "$page", page).url.pathname.startsWith("/login") || store_get($$store_subs ??= {}, "$page", page).url.pathname.startsWith("/admin")) {
      store_get($$store_subs ??= {}, "$page", page).url.pathname.startsWith("/admin");
    }
  }
  {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]-->`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  pop();
}
export {
  _layout as default
};
